import { useCallback, useEffect, useState } from "react";
import { apiFetch } from "../api/apiClient";
import { buildWorkspaceStatusMap } from "../utils/appWorkspaceConfig";

export function useAppWorkspaceStatus() {
  const [statusMap, setStatusMap] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadStatuses = useCallback(async () => {
    try {
      setLoading(true);
      setError("");
      const response = await apiFetch("/api/app-workspace/statuses");
      const data = await response.json();
      setStatusMap(buildWorkspaceStatusMap(data?.statuses || []));
    } catch (loadError) {
      console.error("Failed to load app workspace statuses:", loadError);
      setError(loadError?.error || loadError?.message || "Failed to load app workspace");
      setStatusMap({});
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadStatuses();
  }, [loadStatuses]);

  return {
    statusMap,
    loading,
    error,
    refreshStatuses: loadStatuses,
    setStatusMap,
  };
}

